import styled from 'styled-components';

import TextField from '../../../../components/forms/TextField';

export const TextFieldStyled = styled(TextField)`
  ${({ hideRequiredAsterisk }) => hideRequiredAsterisk
    && `
      span:has(+ &) {
        .nmx-label-asterisk-container {
          display: none;
        }
      }
    `
}
`;

export default TextFieldStyled;
